import { injectable, inject } from "inversify";
import "reflect-metadata";
import HttpService from "src/services/http.service";
import { IGalleryItem } from "../../typings";

@injectable()
export default class HomeDataService {
    @inject(HttpService)
    httpService: HttpService;

    public async getFeatured(): Promise<IGalleryItem[]> {
        return [];
    }

    public async subscribe(email: string): Promise<any> {
        var data = await this.httpService.post("subscribe/", { email });

        return data;
    }
}



// WEBPACK FOOTER //
// ./src/components/home/home.data.service.ts